import { SimpleDialogData } from "common";
import { UserData } from "../../domain/models/users.model";

export function getNotificationSentDialogData(user: UserData): SimpleDialogData {
  return {
    body:
      `An email has been sent to ${user.email} with instructions to create an account and access the broker portal.`,
    title: "Email notification sent"
  }
}
